<ngx-spinner #spinnerElement
             bdColor="rgba(243, 248, 252, 1.0)"
             color="#A961EC"
             name="loadingSpinner"
             size="large"
             type="ball-grid-pulse"
></ngx-spinner>
